import * as z from 'zod/v4';

import { type Outcome, toOutcome } from '../coupon/entry.js';
import { eventTypeIdSchema } from '../sport/entry.js';

/**
 * Transforms outcome result for 1X2 event type.
 *
 * @param root0 dependencies
 * @param root0.outcome Outcome string from API response
 * @returns outcome array
 */
export function get1X2Outcome({ outcome }: { outcome: string }): [Outcome] {
  let outcomeValue = 1; // X
  if (outcome === '1') {
    outcomeValue = 0; // 1
  } else if (outcome === '2') {
    outcomeValue = 2; // 2
  }

  return [toOutcome(outcomeValue)] as const;
}

/**
 * Calculates outcome result for result event type.
 *
 * @param root0 dependencies
 * @param root0.home Home result score
 * @param root0.away Away result score
 * @returns outcome array
 */
function getResultOutcome({ home, away }: { home: number; away: number }): [Outcome, Outcome] {
  return [toOutcome(home), toOutcome(away)] as const;
}

export const outcomeSchema = z
  .object({
    home: z.number(),
    away: z.number(),
    outcome: z.string(),
    // TODO: check with responsible team if eventTypeId can be added, will work for now
    eventTypeId: eventTypeIdSchema,
  })
  .transform(({ home, away, outcome, eventTypeId }, ctx) => {
    switch (eventTypeId) {
      case 'EVENT_1X2':
      case 'HEAD_TO_HEAD':
        return get1X2Outcome({ outcome });
      case 'RESULT':
        return getResultOutcome({ home, away });
      default:
        ctx.addIssue({
          code: 'custom',
          message: `Event type not supported: ${eventTypeId}`,
        });
        return z.NEVER;
    }
  });
